import { createUseStyles } from 'react-jss';
export default createUseStyles((theme) => ({
    header: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
    },
    title: {
        width: '100%',
    },
    content: {
        maxHeight: 0,
        flex: 1,
        opacity: 0,
        overflow: 'hidden',
        transition: 'opacity 1000ms linear, max-height 500ms ease-in-out',
        whiteSpace: 'pre-wrap',
    },
    active: {
        height: 'auto',
        maxHeight: '500px',
        opacity: 1,
        overflow: 'inherit',
        flex: 0,
    },
}));
//# sourceMappingURL=styles.js.map